// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__X9I31","fullScreenTabs":"styles_full-screen-tabs__5Ppy7","fullScreenMask":"styles_full-screen-mask__hAC9L"};